import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { trackPageview } from 'js/utils/tracking';
import HeaderRegionHome from 'js/containers/header-region/HeaderRegion.home';
import { METADATA_CMS_IDS, PAGE_IDS } from 'js/constants/Pages';

import { staticImageAssets } from 'js/constants/Paths';

// import components
import SiteMetaData from 'js/components/generic/Generic.metadata';
import ContentItemGrid from 'js/components/content-item/ContentItem.grid';
import GenericLink from 'js/components/generic/Generic.link';

import SvgTextureLineLong from 'js/components/svg/Svg.texture_line_long';

import CtaPageBlocks from 'js/components/cta/CTA.page-blocks';

// import actions
import { getSiteMetaData, getCurrentPageData } from '../store/app/App.selectors';

const MediaRednerer = ({ media_type, image, video, classname = '' }) => {
  if (media_type === 'image') {
    if (image == '') return;
    return (
      <div className={classname} style={{ marginBottom: 20 }}>
        <img src={image} alt="" />
      </div>
    );
  }

  if (media_type === 'video') {
    if (video == '') return;
    return (
      <div className={classname} style={{ marginBottom: 20 }}>
        <video src={video} autoPlay muted />
      </div>
    );
  }

  return;
};

const PageHomePromo = ({ data }) => {
  const { title = '', description = '', link = {}, image = '', video = '', media_type = 'image' } = data;

  return (
    <div className="homepage--promo" style={{ paddingTop: 50, paddingBottom: 50 }}>
      <div className="container">
        <h2 style={{ color: '#7d5d84', marginBottom: 60 }}>{title}</h2>
        <div className="container--inner" style={{ textAlign: 'center' }}>
          <MediaRednerer media_type={media_type} image={image} video={video} classname={'media'} />
          <p>{description}</p>
          <button className="button--generic button__with-ref">
            <GenericLink data={link} />
          </button>
        </div>
      </div>
    </div>
  );
};

const PageHomeCharacters = ({ data }) => {
  const { title = '', link = {}, image = '', video = '', media_type = 'image' } = data;

  return (
    <div className="homepage--characters">
      <SvgTextureLineLong color={'#bffbfa'} />

      <div className="container">
        <h3>{title}</h3>
        <div className="container--inner" style={{ textAlign: 'center' }}>
          <MediaRednerer media_type={media_type} image={image} video={video} classname={'media'} />
          <button className="button--generic button__with-ref">
            <GenericLink data={link} />
          </button>
        </div>
      </div>
    </div>
  );
};

const PageHomeContentGrid = () => {
  return (
    <div className="homepage--content-grid">
      <SvgTextureLineLong color={'#69cc37'} />

      <div className="container">
        <h3>About the Show</h3>
        <CtaPageBlocks
          ctas={{
            content: [
              {
                image: staticImageAssets('images/static/about_the_show_thumb.png'),
                link: {
                  link_type: 'internal_page',
                  page: 'about',
                  text: 'Find out about the show',
                },
              },
              {
                image: staticImageAssets('images/static/vision_and_values_thumb.png'),
                link: {
                  link_type: 'internal_page',
                  page: 'vision-and-values',
                  text: 'Our vision and values',
                },
              },
            ],
          }}
        />

        {/* <ContentItemGrid /> */}
      </div>
    </div>
  );
};

const PageHome = (props) => {
  const meta = useSelector((state) => {
    return getSiteMetaData(state, METADATA_CMS_IDS[PAGE_IDS.home]);
  });

  const pageData = useSelector((state) => {
    return getCurrentPageData(state, PAGE_IDS.home);
  });

  useEffect(() => {
    trackPageview({ title: PAGE_IDS.home, path: props.path });
  }, []);

  const { header, promo = null, characters = null, ctas = false } = pageData;

  return (
    <>
      <SiteMetaData {...meta} />
      <HeaderRegionHome title={header?.title || ''} description={header?.description || ''} ctas={ctas} />
      {/* {promo != null && <PageHomePromo data={promo} />} */}
      {characters != null && <PageHomeCharacters data={characters} />}
      {PageHomeContentGrid()}
    </>
  );
};

export default PageHome;
